export const RECEIPT_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
} as const;

export const RECEIPT_STATUS_LABEL: Record<string, string> = {
  [RECEIPT_STATUS.PENDING]: "Chờ xác nhận",
  [RECEIPT_STATUS.APPROVED]: "Đã xác nhận",
  [RECEIPT_STATUS.REJECTED]: "Đã từ chối",
};

export const RECEIPT_STATUS_COLOR: Record<string, string> = {
  [RECEIPT_STATUS.PENDING]: "yellow",
  [RECEIPT_STATUS.APPROVED]: "green",
  [RECEIPT_STATUS.REJECTED]: "red",
};
